import jinjaToJS from "jinja-to-js";import __$0 from "./option_category.jinja";import __$1 from "./option_widget.jinja";export default function templateModulesUniversalFiltersOption(ctx) {
    var __result = "";
    var __tmp;
    var __runtime = jinjaToJS.runtime;
    var __filters = jinjaToJS.filters;
    var __globals = jinjaToJS.globals;
    var context = jinjaToJS.createContext(ctx);
    if(context.filter_option.type==="category" && __runtime.boolean(context.filter_option.children)){__result += "\n    ";__result += "" + ((__tmp = (__$0(context))) == null ? "" : __tmp);__result += "\n";} else {__result += "\n    ";__result += "" + ((__tmp = (__$1(context))) == null ? "" : __tmp);__result += "\n";}
    return __result;
}